class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    this.observer = new MutationObserver(this.handleMutation.bind(this));
  }

  async waitForNosto() {
    return new Promise((resolve) => {
      if (typeof window.nostojs === 'function' && window.nostoTemplatesLoaded) {
        resolve();
      } else {
        const checkNosto = () => {
          if (typeof window.nostojs === 'function' && window.nostoTemplatesLoaded) {
            resolve();
          } else {
            setTimeout(checkNosto, 100);
          }
        };

        checkNosto();
      }
    });
  }

  handleMutation(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        const nostoAutocompleteWrapper = this.querySelector('.nosto-autocomplete-wrapper');
        if (nostoAutocompleteWrapper) {
          this.querySelector('.search__input').insertAdjacentElement('afterend', this.querySelector('.field__label'));

          observer.disconnect();
        }
      }
    }
  }

  async connectedCallback() {
    await this.waitForNosto();

    this.observer.observe(document.body, {childList: true, subtree: true});
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton?.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton?.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton?.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
